@import "../portal-card/portal-card.scss";
@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import "../../constants/scrollbar.scss";
@import "../../utils/mixins/mixins.scss";

$pt-icon-svg-inactive-color: var(--color-foreground-de-emp) !important;

:host {
  .portal-notification {
    display: block;
    color: var(--color-foreground);
    font-size: $font-m-size;
    font-family: $font-normal;

    .portal-notifications-icon {
      display: flex;
      align-items: center;
      position: relative;
      .portal-badge {
        right: -6px;
        top: -8px;
        min-width: 20px;
        min-height: 20px;
        line-height: $font-link-line-height;
        position: absolute;
        text-align: center;
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        pointer-events: none;
        border: solid $stroke-m var(--color-foreground-inverse);
        background-color: var(--color-background-inverse);
        font-size: $font-m-size;
        color: var(--color-foreground-inverse);
        font-weight: bold;
        &.show {
          visibility: visible;
        }
        &.hide {
          visibility: hidden;
        }
      }
    }

    .overlay-container {
      position: fixed;
      width: 100%;
      height: 100%;
      z-index: 1000;
      left: 0;
      top: 0;
      pointer-events: auto;
      display: none;

      &.show {
        display: block;
      }

      .notification-container {
        position: absolute;
        right: 50px;
        top: 56px;
        max-width: 500px;
        width: 100%;
        border-radius: $border-radius-s;
        box-shadow: $shadow-menu-elevation;
        box-sizing: border-box;
        background-color: var(--color-background);

        .notification-heading {
          padding: $pad-xxl $pad-xxxl;
          border-bottom: 1px solid var(--color-border-de-emp);
          display: flex;
          align-items: center;
          height: 24px;

          .notification-heading-title {
            flex-basis: 95%;
            font-size: $font-l-size;
            font-weight: $font-weight-semibold;
            color: var(--color-foreground-emp);
          }

          .notification-header-popout {
            float: right;
          }

          .preview {
            color: var(--color-foreground-light);
            font-size: $font-xs-size;
            margin: 8px;
          }
        }
        .notification-list {
          height: calc(100vh - 220px);
          overflow: auto;

          .notifications-empty {
            display: flex;
            justify-content: center;
            align-items: center;
            height: inherit;
          }

          .notification {
            padding: $pad-xxxl $pad-xxxl $pad-l $pad-xxxl;
            border-bottom: 1px solid var(--color-border-de-emp);
            display: flex;
            justify-content: space-between;

            &.with-redirect-url {
              cursor: pointer;
            }

            .notification-icon {
              .pt-icon {
                height: 24px;
                display: inline-block;
                margin-bottom: 10px;

                svg {
                  @include style-svg($pt-icon-svg-inactive-color, $pt-icon-svg-inactive-color, $icon-s);
                }
              }
            }

            .notification-detail {
              width: 100%;
              position: relative;
              margin: 0 $pad-xxl;
              overflow: hidden;
              margin-right: 0;

              .notification-info {
                display: flex;

                .notification-title {
                  font-weight: $font-weight-semibold;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .notification-published {
                  white-space: nowrap;
                  margin: 0 8px;
                }
              }

              .notification-message {
                color: var(--color-foreground-de-emp);
                margin: $pad-xxl 0;
                line-height: 1.5;
              }

              .notification-message-collapsed {
                @include text-ellipse(3);
              }

              .notification-expand {
                position: absolute;
                right: 1px;
                bottom: 10px;
                background-color: transparent;
                height: 20px;
                width: 32px;
                border: none;
                cursor: pointer;
              }
            }

            .notification-actions {
              display: flex;
              align-items: center;
              flex-direction: column;
              .notification-unread-status {
                color: var(--color-primary-focused);
                opacity: 1;
                cursor: pointer;

                &.notification-read {
                  color: var(--color-border);
                  opacity: 0;
                }
              }
            }

            &:focus,
            &:focus-within,
            &:hover {
              background-color: var(--color-hover);
              .notification-actions {
                .notification-unread-status {
                  opacity: 1;
                }
              }
            }
          }

          .notifications-end-list {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 24px 0;
          }
        }
        .notification-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 24px;
          padding: $pad-xxl $pad-xxxl;
          font-weight: $font-weight-semibold;
          border-top: 1px solid var(--color-border-de-emp);
          .notification-global-actions {
            display: flex;
          }
        }
      }

      .notification-container-thin {
        top: 46px;
      }
    }
  }
}
